var _circle, _line, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadFailedExclamationMarkDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 48.5,
    stroke: "#2C303B",
    strokeWidth: 3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 49.5,
    y1: 33.5,
    x2: 49.5,
    y2: 59.5,
    stroke: "#2C303B",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 66.5,
    r: 2.5,
    fill: "#2C303B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadFailedExclamationMarkDark);
export default __webpack_public_path__ + "static/media/download-failed-exclamation-mark-dark.2c70800610e3ee87694e71f8b3f6a021.svg";
export { ForwardRef as ReactComponent };